import { ModalStyled } from 'components/UI/styled/modal-styled';
import React from 'react';
import Container from 'react-bootstrap/esm/Container';
import { Indicacao } from 'models/indicacoes';
import Button from 'react-bootstrap/Button';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  indicacao?: Indicacao;
  onSubmit: (e) => void;
}

const IndicarModal = (props: Props) => {
  return (
    <ModalStyled
      show={props.isOpen}
      onHide={props.onClose}
      className="modal-md"
    >
      <ModalStyled.Header closeButton>
        <ModalStyled.Title>Você confirma a indicação especial?</ModalStyled.Title>
      </ModalStyled.Header>

      <ModalStyled.Body>
        <Container fluid className="pl-0 pr-0">
          <p>
            Após confirmada a opção de crédito ficará disponível para o
            estudante fazer sua solicitação
          </p>
          <div className="talign-right">
            <Button
              className="mr-1"
              onClick={() => props.onClose()}
              variant="outline"
              type="submit"
            >
              Cancelar
            </Button>
            <Button onClick={props.onSubmit} variant="primary" type="submit">
              Confirmar
            </Button>
          </div>
        </Container>
      </ModalStyled.Body>
    </ModalStyled>
  );
};

export default IndicarModal;
